import React, { useState } from 'react';

export default function VisionValuesSection({ initialData, onSave }) {
  const [data, setData] = useState(initialData || {
    vision: '',
    values: '',
    goals: '',
  });

  const handleChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    if (onSave) {
      onSave(data);
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-semibold text-on-surface mb-2">
          Club Vision
        </label>
        <textarea
          value={data.vision}
          onChange={(e) => handleChange('vision', e.target.value)}
          onBlur={handleSave}
          placeholder="Describe the long-term vision and purpose of the club..."
          className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
          rows={4}
        />
        <p className="text-xs text-on-surface-variant mt-1">
          This should describe where you want the club to be in 5-10 years
        </p>
      </div>

      <div>
        <label className="block text-sm font-semibold text-on-surface mb-2">
          Club Values
        </label>
        <input
          type="text"
          value={data.values}
          onChange={(e) => handleChange('values', e.target.value)}
          onBlur={handleSave}
          placeholder="e.g., Excellence, Inclusivity, Integrity, Community"
          className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface"
        />
        <p className="text-xs text-on-surface-variant mt-1">
          Separate core values with commas (typically 3-5 values)
        </p>
      </div>

      <div>
        <label className="block text-sm font-semibold text-on-surface mb-2">
          Key Goals (3-5 Year Horizon)
        </label>
        <textarea
          value={data.goals}
          onChange={(e) => handleChange('goals', e.target.value)}
          onBlur={handleSave}
          placeholder="List key goals for the next 3-5 years, one per line..."
          className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
          rows={4}
        />
        <p className="text-xs text-on-surface-variant mt-1">
          These should be specific, measurable goals aligned with your vision
        </p>
      </div>

      <button
        onClick={handleSave}
        className="btn-primary text-sm px-4 py-2"
      >
        Save Vision & Values
      </button>
    </div>
  );
}
